import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import toast from 'react-hot-toast';
import { getErrorString } from '../../utils';
import { getQueryString } from '../../utils/filters-util';
import { fetchAppointmentsApi } from '../../api/appointments-api';
import { setQuickLinks } from 'reducers/quick-links-slice';

const initialState = {
  activeColumns: [],
  appointments: [],
  loading: true,
  pending: false,
  pagination: {},
};

export const fetchAppointmentsListing = createAsyncThunk(
  'appointments/listing',
  async (updatedParamsObject = {}, { dispatch }) => {
  try {
    const paramsObj = {
      ...updatedParamsObject,
    };
    const res = await fetchAppointmentsApi({}, getQueryString(paramsObj));
    if (res?.status) {
      dispatch(setQuickLinks(res?.user_filters));
    }
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
  },
);

const AppointmentsSlice = createSlice({
  name: 'appointments',
  initialState,
  reducers: {
    setAppointmentsLoading: (state, action) => {
      state.loading = action?.payload?.loading;
    },
    setAppointmentsActiveColumn: (state, action) => {
      state.activeColumns = action?.payload?.activeColumns;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchAppointmentsListing.pending, (state) => {
        state.pending = true;
      })
      .addCase(fetchAppointmentsListing.fulfilled, (state, action) => {
        if (state.loading) {
          state.activeColumns = action?.payload?.active_columns || [];
        }
        state.appointments = action?.payload?.data || [];
        state.loading = false;
        state.pending = false;
        state.pagination = action?.payload?.meta?.pagination || {};
      })
      .addCase(fetchAppointmentsListing.rejected, (state) => {
        state.loading = false;
        state.pending = false;
      });
  },
});

export const { setAppointmentsLoading, setAppointmentsActiveColumn } = AppointmentsSlice.actions;
export default AppointmentsSlice.reducer;
